import React, { useState } from "react";
import { Button, FormControl, Typography } from "@mui/material";
import { useFormik } from "formik";
import TextInput from "../../components/TextInput";
import PrimaryButton from "../../components/Button/PrimaryButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./style.scss";
import {
  validationAadhaarSchema,
  validationPanSchema,
  validationUpdateSchema,
} from "../../utils/validation/customerFormValidation";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  updateFormDetail,
  updateProsureId,
} from "../../store/reducers/prosure";
import ROUTE_PATH from "../../constant/route";
import { handleSaveUser } from "../../store/reducers/prosure/apiThunk";
import dayjs from "dayjs";
import { showToast } from "../../components/Toast";
import { AppDispatch } from "../../store/store";

const DetailForm: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loginData: any = useSelector(
    (state: any) => state?.authentication?.login
  );
  const [idProof, setIdProof] = useState("aadhaar");
  const formik = useFormik({
    initialValues: {
      name: "",
      gender: "",
      mobileNo: "",
      email: "",
      aadhaar: "",
      pan: "",
      address: "",
      pinCode: "",
      dateOfBirth: null,
    },
    validationSchema: idProof === "aadhaar" ? validationAadhaarSchema : validationPanSchema,
    // validationUpdateSchema,
    // idProof === "aadhaar" ? validationAadhaarSchema : validationPanSchema,
    onSubmit: async (values) => {
      const nameParts = values?.name.trim().split(" ");
      let firstName = "";
      let lastName = "";
      if (nameParts.length === 1) {
        showToast("Please enter last name", "error");
      } else {
        firstName = nameParts[0];
        lastName = nameParts.slice(1).join(" "); // Combine remaining parts as the last name
        const data: any = {
          firstName: firstName,
          lastName: lastName,
          gender: values?.gender,
          mobileNo: values?.mobileNo,
          email: values?.email,
          // identity: idProof,
          address: values?.address,
          pinCode: values?.pinCode,
          dateOfBirth: dayjs(values?.dateOfBirth).format("DD-MM-YYYY"),
          agentId: loginData?.agent_id,
        };
        // if (idProof === "aadhaar") {
        //   data["aadhaar"] = values?.aadhaar;
        // } else {
        //   data["pan"] = (values?.pan).toUpperCase();
        // }
        try {
          const res = await dispatch(handleSaveUser(data)).unwrap(); // Unwraps to return raw result or throw error
          if (res?.status === 1) {
            dispatch(updateProsureId(res?.data?.prosureCustomerId));
            dispatch(updateFormDetail(data));
            navigate(ROUTE_PATH.VERIFY_OTP);
            window.scrollTo(0, 0);
          }
        } catch (error) {
          console.error("Error saving user data:", error);
        }
      }
    },
  });

  return (
    <div className="detail-form">
      <form onSubmit={formik.handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput
            name="name"
            value={formik.values.name}
            onChange={(e: any) => {
              const value = e.target.value;
              const regex = /^[A-Za-z.\s]*$/; // Allows alphabets, spaces, and periods
              if (value === "" || regex.test(value)) {
                formik.setFieldValue("name", value);
              }
            }}
            onBlur={formik.handleBlur}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            label="Name"
            inputProps={{
              placeholder: "Choose full name",
              maxLength: 100,
            }}
          />
          <div className="date-field">
            <div className="lg:text-[16px] text-[12px] lg:leading-[25px] leading-[18px] font-semibold text-text-color-1 pb-[10px]">
              Date of Birth
            </div>
            <DatePicker
              value={formik.values.dateOfBirth}
              onChange={(value: any) =>
                formik.setFieldValue("dateOfBirth", value)
              }
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  error:
                    formik.touched.dateOfBirth &&
                    Boolean(formik.errors.dateOfBirth),
                  helperText:
                    formik.touched.dateOfBirth && formik.errors.dateOfBirth
                      ? formik.errors.dateOfBirth
                      : "",
                  onBlur: () => formik.setFieldTouched("dateOfBirth", true),
                },
              }}
            />
          </div>
          <FormControl fullWidth>
            <div className="lg:text-[16px] text-[12px] lg:leading-[25px] leading-[18px] font-semibold text-text-color-1 pb-[10px]">
              Gender
            </div>
            <div className="flex items-center">
              <Button
                className={
                  formik.values.gender === "Male"
                    ? "selectValButton"
                    : "unselectValButton"
                }
                style={{ marginRight: "10px" }}
                onClick={() => formik.setFieldValue("gender", "Male")}
              >
                Male
              </Button>
              <Button
                className={
                  formik.values.gender === "Female"
                    ? "selectValButton"
                    : "unselectValButton"
                }
                onClick={() => formik.setFieldValue("gender", "Female")}
              >
                Female
              </Button>
            </div>
            {formik.touched.gender && formik.errors.gender && (
              <Typography
                color="error"
                variant="caption"
                className="pt-[5px] pl-[10px]"
              >
                {formik.errors.gender}
              </Typography>
            )}
          </FormControl>
          {/* <FormControl fullWidth>
            <div className="lg:text-[16px] text-[12px] lg:leading-[25px] leading-[18px] font-semibold text-text-color-1 pb-[10px]">
              Identity Proof
            </div>
            <div className="flex items-center">
              <Button
                className={
                  idProof === "aadhaar"
                    ? "selectValButton"
                    : "unselectValButton"
                }
                style={{ marginRight: "10px" }}
                onClick={() => setIdProof("aadhaar")}
              >
                Aadhaar
              </Button>
              <Button
                className={
                  idProof === "pan" ? "selectValButton" : "unselectValButton"
                }
                onClick={() => setIdProof("pan")}
              >
                PAN
              </Button>
            </div>
          </FormControl>
          {idProof === "aadhaar" ? (
            <TextInput
              label="Aadhaar Number"
              name="aadhaar"
              fullWidth
              value={formik.values.aadhaar}
              onChange={(e: any) => {
                const value = e.target.value;
                const regex = /^[0-9]*$/;
                if (value === "" || regex.test(value)) {
                  formik.setFieldValue("aadhaar", value);
                }
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.aadhaar && Boolean(formik.errors.aadhaar)}
              helperText={formik.touched.aadhaar && formik.errors.aadhaar}
              inputProps={{ placeholder: "Eg: 2042 4790 2892", maxLength: 12 }}
            />
          ) : (
            <TextInput
              label="PAN"
              name="pan"
              fullWidth
              value={formik.values.pan}
              onChange={(e: any) => {
                const value = e.target.value;
                const regex = /^[a-zA-Z0-9]*$/; // Allow only alphanumeric characters
                if (value === "" || regex.test(value)) {
                  formik.setFieldValue("pan", value);
                }
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.pan && Boolean(formik.errors.pan)}
              helperText={formik.touched.pan && formik.errors.pan}
              inputProps={{ placeholder: "Eg: AYLTB0423L", maxLength: 10 }}
            />
          )} */}
          <TextInput
            label="Email Address"
            name="email"
            type="email"
            fullWidth
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            inputProps={{ placeholder: "Enter email address" }}
          />
          <div>
            <TextInput
              label="Mobile Number"
              name="mobileNo"
              fullWidth
              value={formik.values.mobileNo}
              onChange={(e: any) => {
                const value = e.target.value;
                const regex = /^[0-9]*$/;
                if (value === "" || regex.test(value)) {
                  formik.setFieldValue("mobileNo", value);
                }
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.mobileNo && Boolean(formik.errors.mobileNo)}
              helperText={formik.touched.mobileNo && formik.errors.mobileNo}
              inputProps={{ placeholder: "Enter mobile number", maxLength: 10 }}
            />
            <div className="text-text-color-7 text-[14px] leading-[19px] pt-[10px]">
              <InfoOutlinedIcon className="text-text-color-7" /> Please use the
              customer mobile number to proceed
            </div>
          </div>
          <TextInput
            label="Address"
            name="address"
            fullWidth
            value={formik.values.address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.address && Boolean(formik.errors.address)}
            helperText={formik.touched.address && formik.errors.address}
            inputProps={{ placeholder: "Enter address", maxLength: 200 }}
          />
          <div></div>
          <TextInput
            label="Pincode"
            name="pinCode"
            fullWidth
            value={formik.values.pinCode}
            onChange={(e: any) => {
              const value = e.target.value;
              const regex = /^[0-9]*$/;
              if (value === "" || regex.test(value)) {
                formik.setFieldValue("pinCode", value);
              }
            }}
            onBlur={formik.handleBlur}
            error={formik.touched.pinCode && Boolean(formik.errors.pinCode)}
            helperText={formik.touched.pinCode && formik.errors.pinCode}
            inputProps={{
              placeholder: "Enter pincode",
              maxLength: 6,
            }}
          />
        </div>
        <div>
          <PrimaryButton
            label={
              <div className="flex items-center justify-center w-[100%] font-black">
                <div className="text-[14px] leading-[18px] lg:text-[24px] lg:leading-[30px] ">
                  Request OTP
                </div>
              </div>
            }
            type="submit"
            classname="sm:w-[50%] w-[100%] mx-auto"
            style={{ marginTop: "50px" }}
          />
        </div>
      </form>
    </div>
  );
};

export default DetailForm;
